import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/Akkhor";
import { useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import UserDropDown from "../component/UserDropDown";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/Api";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";


export default function FormSubjectsPage() {
    const { user } = useSelector((state) => state.auth);
    const school_id = user && user.data && user.data.school_id>0?user.data.school_id:0;
    const  {id}  = useParams();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [refresh, setRefresh] = useState(false);
    
    const defaultdetail = {
        school_id, author_id:user.data.id,grade_id:'', title:'',numlessons:'',lessionperweek:'', status:1,
    }
    useEffect(
        function () {
            if(id>0)
            {
                let mounted = true;
                Axios.get(URL_LIST_ALL  + "subjects/"+id,user.config)
                    .then( async (res) => {
                    if (res.data.status === "success") {
                        if (mounted){
                            setDetail(res.data.data);
                        } 
                    } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                    return () => (mounted = false);
            }
        },[user,id,refresh]
      );
    const formik = useFormik({
        initialValues:detail?detail:defaultdetail,
        enableReinitialize:true,
        validationSchema: Yup.object().shape({
          grade_id: Yup.string().trim().nullable().required('Chọn khối'),
          title: Yup.string().trim().nullable().required('Nhập tên lớp').max(150, "Độ dài không quá 150 ký tự"),
          numlessons: Yup.string().trim().nullable().required('Nhập tổng số tiết'),
          lessionperweek: Yup.string().trim().nullable().required('Nhập số tiết trong tuần')
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setLoading(true)
            if(id>0)
            {
                Axios.put(URL_LIST_ALL+'subjects/'+id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật môn học thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    }else{
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }else{
                Axios.post(URL_LIST_ALL+'subjects', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới môn học thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    }else{
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

  return (
    <AkkhorLayout  idrole="list-subjects">
      <div className="card height-auto mt-5">
        <div className="card-body">
            <div className="heading-layout1">
                <div className="item-title">
                    <h3>Môn học</h3>
                </div>
            </div>
            <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                <div className="row">
                    <div className="col-xl-4 col-lg-6 col-12 form-group">
                        <label>Khối <span className="text-danger">*</span></label>
                        <UserDropDown apiname={"grades?orderby=title-ASC&school_id="+school_id} placeholder="Chọn khối" colvalue={'grades.id'} colname={'grades.title'} formik={formik} name='grade_id'
                        onChange={async(e)=>{
                            await formik.setFieldValue('grade_id',e)
                            await formik.setFieldValue('class_id','')
                            await formik.setFieldTouched('class_id')
                        }}></UserDropDown>
                        <AlertErrorForm formik={formik} name="grade_id"></AlertErrorForm>
                    </div>
                    <div className="col-xl-4 col-lg-6 col-12 form-group">
                        <label>Tên môn học <span className="text-danger">*</span></label>
                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off"/>
                        <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                    </div>
                    <div className="col-xl-4 col-lg-6 col-12 form-group">
                        <label>Tổng số tiết <span className="text-danger">*</span></label>
                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("numlessons")} autoComplete="off"/>
                        <AlertErrorForm formik={formik} name="numlessons"></AlertErrorForm>
                    </div>
                    <div className="col-xl-4 col-lg-6 col-12 form-group">
                        <label>Số tiết trong tuần <span className="text-danger">*</span></label>
                        <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("lessionperweek")} autoComplete="off"/>
                        <AlertErrorForm formik={formik} name="lessionperweek"></AlertErrorForm>
                    </div>
                    <div className="col-xl-4 col-lg-6 col-12 form-group">
                        <label>Trạng thái</label>
                        <select className="form-control height32" {...formik.getFieldProps("status")}>
                            <option value="0">Khoá</option>
                            <option value="1">Hoạt động</option>
                        </select>
                    </div>
                    <div className="col-xl-4 col-lg-6 col-12 form-group">
                        <label>Sử dụng ở Khảo Thí</label>
                        <select className="form-control height32" {...formik.getFieldProps("istree")}>
                            <option value="0">Không</option>
                            <option value="1">Có</option>
                        </select>
                    </div>
                    
                    <div className="col-12 form-group mg-t-8">
                    <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner />:<>Lưu môn học</>}</button>
                        <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                    </div>
                </div>
            </form>
        </div>
      </div>
    </AkkhorLayout>
  );
}
